export const WHATSAPP_NUMBER = "4915144396795";
export const WHATSAPP_DISPLAY = "+49 151 44396795";

export const getWhatsAppUrl = (message) => {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};

export const WHATSAPP_URL = getWhatsAppUrl(
  "Hi, I'm interested in learning more about IRE Berlin's real estate investment services."
);
